import Vue from "vue";

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import "../scss/main.scss"
const requireComponent = require.context(
    './components',
    false,
    /Elepy[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);

    const componentName = upperFirst(
        camelCase(
            // Gets the file name regardless of folder depth
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    );


    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
});
